<!-- Footer -->
<div class="d-flex justify-content-center container">
  <a (click)="openNewTab(tosUrl)" href="javascript:void(0)" *ngIf="tosUrl">
    {{ 'FOOTER.TOS' | translate }}
  </a>
  <a (click)="openNewTab(gdprUrl)" href="javascript:void(0)" *ngIf="gdprUrl">
    {{ 'FOOTER.GDPR' | translate }}
  </a>
  <a (click)="openNewTab('https://anpc.ro/')" href="javascript:void(0)">
    {{ 'FOOTER.ANPC' | translate }}
  </a>
  <a (click)="openNewTab(privacyPolicyUrl)" href="javascript:void(0)" *ngIf="privacyPolicyUrl">
    {{ 'FOOTER.PRIVACY_POLICY' | translate }}
  </a>
  <a (click)="openNewTab(cookiesPolicyUrl)" href="javascript:void(0)" *ngIf="cookiesPolicyUrl">
    {{ 'FOOTER.COOKIE_POLICY' | translate }}
  </a>
  <a (click)="openCookieSettings()" href="javascript:void(0)">
    {{ 'FOOTER.COOKIE_SETTINGS' | translate }}
  </a>
  <a (click)="openNewTab(speakUpPolicyUrl)" href="javascript:void(0)" *ngIf="speakUpPolicyUrl">
    {{ 'FOOTER.SPEAK_UP_POLICY' | translate }}
  </a>
</div>
<div class="d-flex justify-content-center mt-2 align-items-center">
  <div class="mr-1">
    <img src="assets/images/logo/netopia_banner.png" alt="Netopia Logo" />
  </div>
    <div>
        <img src="assets/images/iso27001.png" style="max-height: 50px !important; max-width: 50px !important;" alt="ISO27001 Logo" />
    </div>

</div>
<!--/ Footer -->
